import * as React from 'react'

import { Loader } from '@/ui'
import { Portal } from '@/ui/overlays/Portal'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import {
  usePrintJobProgress,
  usePrintJobRunning,
} from '../stores/printJobStore'
import { describeTaskProgress } from '@/modules/shared/utils/taskProgressLabel'
import { useElapsedTick } from '@/modules/shared/hooks/useElapsedTick'


export const PrintJobOverlay: React.FC = () => {
  const isGenerating = usePrintJobRunning()
  const progress = usePrintJobProgress()
  const { t } = useLocalize()
  // Zegar tyka tylko, gdy cokolwiek leci - inaczej odswiezalby ekran bez powodu.
  useElapsedTick(isGenerating)

  if (!isGenerating) return null

  return (
    <Portal layer="modal">
      <div
        className="tw-fixed tw-inset-0 tw-z-[10050] tw-flex tw-cursor-wait tw-items-center tw-justify-center tw-bg-black/40 tw-backdrop-blur-[2px]"
        role="alert"
        aria-busy="true"
        aria-live="polite"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-bg-white tw-px-8 tw-py-6 tw-shadow-xl">
          <Loader
            size="lg"
            textPosition="top"
            text={`${t('printout.processing-in-progress')}${
              // Ten sam opis co na niebieskim pasku: licznik dopiero w fazie skladania,
              // a wczesniej nazwa etapu z uplywajacym czasem - zeby bylo widac, ze cos
              // sie dzieje. Bez tego ekran stal na "0/267" przez cala faze liczenia.
              describeTaskProgress(progress, t).suffix
            }`}
            textClassName="tw-text-sm tw-font-medium"
          />
        </div>
      </div>
    </Portal>
  )
}

export default PrintJobOverlay
